import _ from 'lodash';
import * as api from '../api';

import * as UtilsForm from '../utils/form';

import { FormSet, FormSets } from './store';

export const transformFormSet = (
  formSet: api.PrevisitFormSet.PrevisitFromSetWithPatientData,
): FormSet => {
  const {
    previsitFormSet,
    practice,
    provider,
    encounter,
    virtualVisit,
    covidInstruction,
  } = formSet;
  const { id, completed, forms, practicePreference, status } = previsitFormSet;
  const transformedPracticePreference = {
    ...practicePreference,
    patientInsuranceInformationPayors:
      practicePreference.patientInsuranceInformationPayors
        ? practicePreference.patientInsuranceInformationPayors.sort()
        : [],
  };
  return {
    id,
    completed,
    practice,
    provider,
    encounter,
    practicePreference: transformedPracticePreference,
    documents: [],
    forms,
    virtualVisit,
    covidInstruction,
    status,
  };
};

export const transformFormSets = (
  formSets: api.PrevisitFormSet.PrevisitFromSetWithPatientData[],
): FormSets => {
  return Object.fromEntries(
    formSets.map((formSet) => [
      formSet.previsitFormSet.id,
      transformFormSet(formSet),
    ]),
  );
};

export const sanitizeFormSets = (args: {
  server: FormSets;
  merged: FormSets;
}): FormSets => {
  const { server, merged } = args;
  return Object.fromEntries(
    Object.values(merged)
      .filter((mergedFormSet) => Boolean(server[mergedFormSet.id]))
      .map((mergedFormSet) => [
        mergedFormSet.id,
        sanitizeForms({
          mergedFormSet,
          serverFormSet: server[mergedFormSet.id],
        }),
      ]),
  );
};

const sanitizeForms = (args: {
  mergedFormSet: FormSet;
  serverFormSet: FormSet;
}): FormSet => {
  const { mergedFormSet, serverFormSet } = args;
  const serverFormIds = _.flattenDeep(
    Object.values(serverFormSet.forms).map((form) => form.id),
  );
  const forms = Object.fromEntries(
    Object.values(mergedFormSet.forms)
      .filter((form) => !UtilsForm.isDocumentForm(form.id))
      .filter((form) => serverFormIds.includes(form.id))
      .map((form) => [form.id, form]),
  );
  const clientDocumentForm = Object.values(mergedFormSet.forms).find((form) =>
    UtilsForm.isDocumentForm(form.id),
  );
  const documentForm = Object.fromEntries(
    Object.values(serverFormSet.forms)
      .filter((form) => UtilsForm.isDocumentForm(form.id))
      .map((form) => [
        form.id,
        {
          ...form,
          status: clientDocumentForm ? clientDocumentForm.status : form.status,
        },
      ]),
  );
  return {
    ..._.omit(mergedFormSet, ['forms']),
    forms: { ...forms, ...documentForm },
  };
};
